<script>
/* eslint-disable */
import {consultar, sincronizar, alterarStatusBem, checaDisponibilidade} from "@/domain/integra/services/porto-remocao"
import {ErpSelect} from 'uloc-vue-plugin-erp'
import {UTable, UTd, UTh, UTr} from "uloc-vue"

// Status do fluxo de remoção (sistema de salvados Porto/FourWay)
const STATUS = {
  AGUARDANDO_PATIO: 1,
  PENDENTE_REMOCAO: 1603,
  PENDENTE_CONTATO: 517,
  REMOCAO_SOLICITADA: 1604,
  EM_REMOCAO: 513,
  VEICULO_RECEBIDO: 3,
  SUSPENSA: 1658,
  LIBERADA: 1665,
  IMPEDIMENTO: 1622,
  CANCELADA: 1654
}

// Status que podem ser consultados (recebimento)
const filtroStatus = [
  {label: 'Pendente de remoção pelo leiloeiro', value: STATUS.PENDENTE_REMOCAO},
  {label: 'Pendente contato do leiloeiro com o local', value: STATUS.PENDENTE_CONTATO},
  {label: 'Remoção solicitada pelo leiloeiro', value: STATUS.REMOCAO_SOLICITADA},
  {label: 'Em remoção', value: STATUS.EM_REMOCAO},
  {label: 'Veículo recebido', value: STATUS.VEICULO_RECEBIDO},
  {label: 'Remoção suspensa - análise da CIA', value: STATUS.SUSPENSA},
  {label: 'Análise concluída - remoção liberada', value: STATUS.LIBERADA},
  {label: 'Remoção cancelada', value: STATUS.CANCELADA}
]

// Ações de avanço que o leiloeiro pode empurrar para a Porto
const acoes = [
  {idStatus: STATUS.PENDENTE_CONTATO, label: 'Pendente contato c/ local', color: 'blue-grey'},
  {idStatus: STATUS.REMOCAO_SOLICITADA, label: 'Remoção solicitada (+data)', color: 'indigo', comentario: true, promptMsg: 'Informe a data do agendamento da remoção:'},
  {idStatus: STATUS.EM_REMOCAO, label: 'Em remoção', color: 'orange'},
  {idStatus: STATUS.VEICULO_RECEBIDO, label: 'Veículo recebido', color: 'positive'},
  {idStatus: STATUS.SUSPENSA, label: 'Suspensa (análise CIA)', color: 'negative', comentario: true, promptMsg: 'Informe o motivo da suspensão / divergência para análise da CIA:'}
]

// Normaliza as notas/comentários da Porto (nome do campo/estrutura pode variar no retorno da WS)
function normalizarMensagens(row) {
  // A WS da Porto devolve as notas em Comentarios.Comentario[]; mantém fallback p/ outros nomes
  let raw = row && (
    (row.Comentarios && row.Comentarios.Comentario) ||
    row.Mensagens || row.Notas || row.mensagens || row.notas
  )
  if (raw && !Array.isArray(raw)) raw = [raw]
  if (!Array.isArray(raw)) return []
  return raw.map(m => {
    if (m == null) return null
    if (typeof m === 'string') return {data: null, autor: null, status: null, texto: m}
    return {
      data: m.Data || m.DataHora || m.data || m.dataHora || null,
      autor: m.Autor || m.Usuario || m.autor || m.usuario || null,
      status: m.Status || m.status || null,
      texto: m.Texto || m.Mensagem || m.Descricao || m.Comentario || m.texto || m.mensagem || m.descricao || m.comentario || ''
    }
  }).filter(Boolean)
}

// Anexos (cartas de remoção) vêm em Anexos.Anexo[], com o conteúdo em base64 no campo Arquivo
function normalizarAnexos(row) {
  let raw = row && row.Anexos && row.Anexos.Anexo
  if (raw && !Array.isArray(raw)) raw = [raw]
  if (!Array.isArray(raw)) return []
  return raw.filter(a => a && a.Arquivo)
}

function base64ParaBytes(b64) {
  const limpo = String(b64).replace(/\s/g, '')
  const bin = atob(limpo)
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return bytes
}

let listStorage = [
  {label: 'Pátio / Conta', name: 'conta', active: true},
  {label: 'Sinistro', name: 'sinistro', active: true},
  {label: 'Objeto/Nº', name: 'objeto', active: true},
  {label: 'Placa', name: 'placa', active: true},
  {label: 'Chassi', name: 'chassi', active: true},
  {label: 'Veículo', name: 'veiculo', active: true},
  {label: 'Local de remoção', name: 'local', active: true},
  {label: 'Contato', name: 'contato', active: true},
  {label: 'Status Porto', name: 'statusPorto', active: true},
  {label: 'Mensagens', name: 'mensagens', active: true},
  {label: 'Anexos', name: 'anexos', active: true},
  {label: 'Bem local', name: 'bem', active: true},
  {label: 'Ações', name: 'options', active: true}
]

export default {
  name: 'PortoRemocaoListaSalvados',
  inject: ['page'],
  components: {ErpSelect, UTable, UTh, UTr, UTd},
  data() {
    return {
      filtroStatus: filtroStatus,
      acoes: acoes,
      seletor: STATUS.PENDENTE_REMOCAO,
      msgModal: {open: false, row: null},
      anexosModal: {open: false, row: null},
      canceladas: [],
      mostrarAlertaCanceladas: true,
      contas: [], // logins da Porto (um por pátio)
      conta: null, // null = todas as contas
      errosConsulta: {},
      table: {
        serverData: [],
        serverPagination: {page: 1, rowsNumber: 0, rowsPerPage: 500},
        columns: listStorage.map(o => ({...o, field: o.name, align: 'left', sortable: false})),
        loading: false
      }
    }
  },
  computed: {
    multiConta() {
      return this.contas.length > 1
    },
    contasOptions() {
      return [{label: 'Todos os pátios', value: null}].concat(
        this.contas.map(c => ({label: c.nome || c.login, value: c.id}))
      )
    },
    errosConsultaLista() {
      return Object.keys(this.errosConsulta || {}).map(id => {
        const conta = this.contas.find(c => c.id === id)
        return {conta: (conta && (conta.nome || conta.login)) || id, erro: this.errosConsulta[id]}
      })
    },
    visibledColumns() {
      // a coluna de conta/pátio só faz sentido quando o cliente tem mais de um login
      return listStorage
        .filter(i => i.active && (i.name !== 'conta' || this.multiConta))
        .map(i => i.name)
    },
    msgModalMensagens() {
      return this.msgModal.row ? normalizarMensagens(this.msgModal.row) : []
    },
    anexosModalItens() {
      return this.anexosModal.row ? normalizarAnexos(this.anexosModal.row) : []
    }
  },
  mounted() {
    this.page.setActive('salvados')
    const container = document.querySelector('.u-erp-layout-container')
    !container.classList.contains('app-globalconfig') && container.classList.add('app-globalconfig')
    this.carregarContas()
    this.consultar()
    this.verificarCanceladas()
  },
  beforeDestroy() {
    document.querySelector('.u-erp-layout-container').classList.remove('app-globalconfig')
  },
  methods: {
    request() {},
    carregarContas() {
      checaDisponibilidade()
        .then(({data}) => {
          this.contas = Array.isArray(data.contas) ? data.contas : []
        })
        .catch(() => {})
    },
    consultar() {
      this.table.loading = true
      consultar(this.seletor, this.conta)
        .then(({data}) => {
          this.table.loading = false
          let salvados = Array.isArray(data.salvados) ? data.salvados : []
          this.table.serverData = salvados
          this.table.serverPagination.rowsNumber = salvados.length
          this.errosConsulta = data.erros || {}
        })
        .catch(error => {
          this.table.loading = false
          this.alertApiError(error)
        })
    },
    nomeConta(row) {
      if (row && row.contaNome) return row.contaNome
      const conta = row && row.conta ? this.contas.find(c => c.id === row.conta) : null
      return conta ? (conta.nome || conta.login) : '—'
    },
    verificarCanceladas() {
      consultar(STATUS.CANCELADA, this.conta)
        .then(({data}) => {
          const salvados = Array.isArray(data.salvados) ? data.salvados : []
          this.canceladas = salvados
          if (salvados.length) this.mostrarAlertaCanceladas = true
        })
        .catch(() => {})
    },
    verCanceladas() {
      this.seletor = STATUS.CANCELADA
      this.consultar()
    },
    sincronizar() {
      this.$uloc.loading.show({message: 'Sincronizando salvados com a Porto Seguro...'})
      sincronizar(null, this.conta)
        .then(({data}) => {
          this.$uloc.loading.hide()
          const r = data.resumo || {}
          this.$uloc.notify({
            color: (r.falhas ? 'warning' : 'positive'),
            message: `Sincronização: ${r.criados || 0} criados, ${r.atualizados || 0} atualizados, ${r.falhas || 0} falhas`,
            position: 'bottom-left'
          })
          this.consultar()
        })
        .catch(error => {
          this.$uloc.loading.hide()
          this.alertApiError(error)
        })
    },
    veiculo(row) {
      return [row.Marca, row.Modelo, row.AnoModelo].filter(Boolean).join(' ')
    },
    mensagensDe(row) {
      return normalizarMensagens(row)
    },
    ultimaMensagem(row) {
      const msgs = normalizarMensagens(row)
      if (!msgs.length) return ''
      const texto = msgs[msgs.length - 1].texto || ''
      return texto.length > 40 ? texto.slice(0, 40) + '…' : texto
    },
    abrirMensagens(row) {
      if (!normalizarMensagens(row).length) return
      this.msgModal.row = row
      this.msgModal.open = true
    },
    fecharMensagens() {
      this.msgModal.open = false
      this.msgModal.row = null
    },
    anexosDe(row) {
      return normalizarAnexos(row)
    },
    nomeAnexo(anexo) {
      return String((anexo && anexo.Nome) || '').split('/').pop()
    },
    abrirAnexos(row) {
      if (!normalizarAnexos(row).length) return
      this.anexosModal.row = row
      this.anexosModal.open = true
    },
    fecharAnexos() {
      this.anexosModal.open = false
      this.anexosModal.row = null
    },
    abrirAnexo(anexo) {
      if (!anexo || !anexo.Arquivo) return
      const nome = this.nomeAnexo(anexo) || 'anexo'
      const isHtml = /\.html?$/i.test(nome)
      let bytes
      try {
        bytes = base64ParaBytes(anexo.Arquivo)
      } catch (e) {
        this.$uloc.notify({color: 'negative', message: 'Não foi possível ler o anexo.', position: 'bottom-left'})
        return
      }
      const blob = new Blob([bytes], {type: isHtml ? 'text/html;charset=utf-8' : 'application/octet-stream'})
      const url = URL.createObjectURL(blob)
      if (isHtml) {
        window.open(url, '_blank')
      } else {
        const a = document.createElement('a')
        a.href = url
        a.download = nome
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    },
    executarAcao(row, acao) {
      if (!row.bemLocal || !row.bemLocal.id) {
        this.$uloc.dialog({
          title: 'Salvado ainda não importado',
          message: 'Este salvado ainda não possui um Bem local. Clique em "Sincronizar" antes de avançar o status.',
          color: 'warning'
        })
        return
      }

      if (acao.comentario) {
        this.$uloc.dialog({
          title: acao.label,
          message: acao.promptMsg || 'Informe um comentário para a Porto:',
          prompt: {model: '', type: 'text'},
          cancel: true,
          color: 'primary'
        }).then(comentario => {
          if (!comentario || !String(comentario).trim()) {
            this.$uloc.notify({color: 'warning', message: 'Comentário obrigatório para esta ação.', position: 'bottom-left'})
            return
          }
          this.enviarStatus(row, acao.idStatus, comentario)
        }).catch(() => {})
        return
      }

      this.$uloc.dialog({
        title: 'Confirmar ação',
        message: `Enviar "${acao.label}" para a Porto Seguro?`,
        cancel: true,
        color: 'primary'
      }).then(() => {
        this.enviarStatus(row, acao.idStatus, null)
      }).catch(() => {})
    },
    enviarStatus(row, idStatus, comentario) {
      this.$uloc.loading.show({message: 'Enviando status para a Porto...'})
      alterarStatusBem(row.bemLocal.id, idStatus, comentario)
        .then(({data}) => {
          this.$uloc.loading.hide()
          this.$uloc.notify({
            color: 'positive',
            message: `Status "${data.status}" enviado com sucesso.`,
            position: 'bottom-left'
          })
          this.consultar()
        })
        .catch(error => {
          this.$uloc.loading.hide()
          this.alertApiError(error)
        })
    }
  }
}
</script>

<template>
  <div class="flex col-grow no-wrap globalconfigs-container">
    <transition name="slide" appear>
      <div class="transition-generic w-full">
        <div class="global-config-container">
          <div v-if="mostrarAlertaCanceladas && canceladas.length" class="pr-alert-canceladas">
            <div class="pr-alert-icon">⚠</div>
            <div class="pr-alert-text">
              <strong>{{ canceladas.length }}</strong>
              {{ canceladas.length > 1 ? 'remoções canceladas' : 'remoção cancelada' }}
              pela seguradora.
            </div>
            <e-btn size="sm" color="white" label="Ver" @click="verCanceladas"/>
            <a class="pr-alert-close" @click="mostrarAlertaCanceladas = false" title="Dispensar">✕</a>
          </div>

          <div class="m-t m-b-lg">
            <h2 class="i-title">Salvados em remoção — Porto Seguro</h2>
            <div class="m-t-md">
              <template v-if="multiConta">
                Pátio:
                <erp-select class="m-t-sm m-r" size="2" :options="contasOptions" v-model="conta" @input="consultar"/>
              </template>
              Status:
              <erp-select class="m-t-sm" size="2" :options="filtroStatus" v-model="seletor" @input="consultar"/>
              <e-btn @click="consultar" class="m-t-xs m-l-xs" label="Consultar"/>
              <e-btn @click="sincronizar" class="m-t-xs m-l-xs"
                     :label="conta ? 'Sincronizar este pátio' : 'Sincronizar'"/>
            </div>

            <div v-if="errosConsultaLista.length" class="m-t-sm text-negative font-11">
              <div v-for="(e, i) in errosConsultaLista" :key="i">
                Falha na conta <strong>{{ e.conta }}</strong>: {{ e.erro }}
              </div>
            </div>
          </div>

          <div class="erp-list" style="padding: 0 !important; margin: 0">
            <u-table
              ref="table"
              color="primary"
              :data="table.serverData"
              :columns="table.columns"
              :visible-columns="visibledColumns"
              row-key="Sinistro"
              :pagination.sync="table.serverPagination"
              @request="request"
              :loading="table.loading"
              class="erp-table"
              :rows-per-page-options="[100, 300, 500]"
            >
              <u-tr slot="header" slot-scope="props">
                <u-th v-for="col in props.cols" :key="col.name" :props="props">
                  {{ col.label }}
                </u-th>
              </u-tr>

              <u-tr slot="body" slot-scope="props" :props="props">
                <u-td key="conta" :props="props">{{ nomeConta(props.row) }}</u-td>
                <u-td key="sinistro" :props="props">{{ props.row.Sinistro }}</u-td>
                <u-td key="objeto" :props="props">{{ props.row.Objeto }} / {{ props.row.Numero }}</u-td>
                <u-td key="placa" :props="props">{{ props.row.Placa }}</u-td>
                <u-td key="chassi" :props="props">{{ props.row.Chassi }}</u-td>
                <u-td key="veiculo" :props="props">{{ veiculo(props.row) }}</u-td>
                <u-td key="local" :props="props">{{ props.row.LocalRemocao }}</u-td>
                <u-td key="contato" :props="props">{{ props.row.ContatoRemocao }}</u-td>
                <u-td key="statusPorto" :props="props">{{ props.row.Status }}</u-td>
                <u-td key="mensagens" :props="props">
                  <a v-if="mensagensDe(props.row).length" class="pr-msg-cell" @click="abrirMensagens(props.row)">
                    <span class="pr-msg-badge">{{ mensagensDe(props.row).length }}</span>
                    <span class="pr-msg-preview">{{ ultimaMensagem(props.row) }}</span>
                  </a>
                  <span v-else class="text-grey">—</span>
                </u-td>
                <u-td key="anexos" :props="props">
                  <a v-if="anexosDe(props.row).length" class="pr-msg-cell" @click="abrirAnexos(props.row)">
                    <span class="pr-msg-badge">{{ anexosDe(props.row).length }}</span>
                    <span class="pr-msg-preview">cartas de remoção</span>
                  </a>
                  <span v-else class="text-grey">—</span>
                </u-td>
                <u-td key="bem" :props="props">
                  <div v-if="props.row.bemLocal">
                    #{{ props.row.bemLocal.id }}
                    <div class="font-10">{{ props.row.bemLocal.statusTitulo }}</div>
                    <div v-if="props.row.bemLocal.patio" class="font-10 text-grey">{{ props.row.bemLocal.patio }}</div>
                  </div>
                  <span v-else class="text-grey">não importado</span>
                </u-td>
                <u-td key="options" :props="props">
                  <div class="flex" style="gap: 4px; flex-wrap: wrap">
                    <e-btn
                      v-for="acao in acoes"
                      :key="acao.idStatus"
                      size="sm"
                      :label="acao.label"
                      :disable="!props.row.bemLocal"
                      @click="executarAcao(props.row, acao)"
                    />
                  </div>
                </u-td>
              </u-tr>
            </u-table>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="msgModal.open" class="pr-msg-overlay" @click.self="fecharMensagens">
      <div class="pr-msg-modal">
        <div class="pr-msg-modal-header">
          <div>
            <strong>Mensagens — Sinistro {{ msgModal.row && msgModal.row.Sinistro }}</strong>
            <div class="font-10 text-grey" v-if="msgModal.row">
              {{ msgModal.row.Placa }} · {{ veiculo(msgModal.row) }}
            </div>
          </div>
          <e-btn size="sm" label="Fechar" @click="fecharMensagens"/>
        </div>
        <div class="pr-msg-modal-body">
          <div v-if="!msgModalMensagens.length" class="text-grey text-center m-t">
            Nenhuma mensagem registrada.
          </div>
          <div v-for="(m, i) in msgModalMensagens" :key="i" class="pr-msg-item">
            <div class="pr-msg-item-meta">
              <span v-if="m.autor" class="pr-msg-item-autor">{{ m.autor }}</span>
              <span v-if="m.status" class="pr-msg-item-status">{{ m.status }}</span>
              <span v-if="m.data" class="pr-msg-item-data">{{ m.data }}</span>
            </div>
            <div class="pr-msg-item-texto">{{ m.texto }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="anexosModal.open" class="pr-msg-overlay" @click.self="fecharAnexos">
      <div class="pr-msg-modal">
        <div class="pr-msg-modal-header">
          <div>
            <strong>Anexos — Sinistro {{ anexosModal.row && anexosModal.row.Sinistro }}</strong>
            <div class="font-10 text-grey" v-if="anexosModal.row">
              {{ anexosModal.row.Placa }} · {{ veiculo(anexosModal.row) }}
            </div>
          </div>
          <e-btn size="sm" label="Fechar" @click="fecharAnexos"/>
        </div>
        <div class="pr-msg-modal-body">
          <div v-if="!anexosModalItens.length" class="text-grey text-center m-t">
            Nenhum anexo disponível.
          </div>
          <div v-for="(a, i) in anexosModalItens" :key="i" class="pr-anx-item">
            <div class="pr-anx-info">
              <div class="pr-anx-tipo">{{ a.Descricao || a.Tipo || 'Anexo' }}</div>
              <div class="font-10 text-grey">{{ nomeAnexo(a) }}</div>
            </div>
            <e-btn size="sm" color="primary" label="Abrir" @click="abrirAnexo(a)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" src="../assets/default.styl"></style>
